export function getConfidenceTier(trackedPeriodCount, hasSetupData) {
    if (trackedPeriodCount >= 4) {
        return { tier: 'confident', label: `Based on ${trackedPeriodCount} cycles of your data` };
    }
    if (trackedPeriodCount >= 2) {
        return { tier: 'growing', label: `Getting more accurate — ${trackedPeriodCount} cycles tracked` };
    }
    if (trackedPeriodCount === 1) {
        return { tier: 'learning', label: hasSetupData ? 'Based on your estimate' : 'Based on 1 tracked period' };
    }
    return { tier: 'learning', label: 'Based on your estimate' };
}
